import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-data",
  "use": "icon-soc-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-data\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 704h160v160H160V704zm272 0h160v160H432V704zm272 0h160v160H704V704z\" />\r\n  <path d=\"M224 160v448h64V288l160 192 160-224 128 160h64V160h-64v320L608 304 448 528 288 336V160h-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-data.svg
// module id = JiWK
// module chunks = 410